import React, { Component } from "react";
import VariantSlider from "./VariantSlider";

class VariantSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false,
        };
    }

    componentDidMount() {
        if (this.props.items) {
            this.setState({
                isMounted: true,
                items: [...this.props.items],
            });
        }
        if (this.props.settings) {
            this.settings = this.props.settings;
        }
    }
    render() {
        const { title, itemType } = this.props;

        return (
            <div className="variant-selector">
                {title &&
                    <h3 className="variant-selector__title">{title}</h3>
                }
                {this.state.isMounted && (
                    <VariantSlider items={this.state.items} itemType={itemType} cssBlock="variant-selector" />
                )}
            </div>
        );
    }
}
export default VariantSelector;
